import React from 'react';
import '../../css/common/Skeleton.css';

const SHAPE_CLASS = {
  block: 'skeleton--block',
  line: 'skeleton--line',
  pill: 'skeleton--pill',
  circle: 'skeleton--circle',
  avatar: 'skeleton--avatar',
  icon: 'skeleton--icon',
  button: 'skeleton--button',
  media: 'skeleton--media',
};

const toCssLength = (value) => {
  if (value == null || value === '') return undefined;
  return typeof value === 'number' ? `${value}px` : value;
};

export default function Skeleton({
  as: Element = 'span',
  shape = 'line',
  width,
  height,
  size,
  radius,
  animated = true,
  className = '',
  style,
  ...rest
}) {
  const vars = {
    ...(style || {}),
  };
  const cssWidth = toCssLength(width);
  const cssHeight = toCssLength(height);
  const cssSize = toCssLength(size);
  const cssRadius = toCssLength(radius);

  if (cssWidth) vars['--skeleton-width'] = cssWidth;
  if (cssHeight) vars['--skeleton-height'] = cssHeight;
  if (cssSize) vars['--skeleton-size'] = cssSize;
  if (cssRadius) vars['--skeleton-radius'] = cssRadius;

  const classes = [
    'skeleton',
    SHAPE_CLASS[shape] || SHAPE_CLASS.line,
    animated ? 'skeleton--animated' : 'skeleton--quiet',
    className,
  ].filter(Boolean).join(' ');

  return <Element className={classes} style={vars} aria-hidden="true" {...rest} />;
}

export const SkeletonBlock = (props) => <Skeleton shape="block" {...props} />;
export const SkeletonLine = (props) => <Skeleton shape="line" {...props} />;
export const SkeletonPill = (props) => <Skeleton shape="pill" {...props} />;
export const SkeletonCircle = (props) => <Skeleton shape="circle" {...props} />;
export const SkeletonAvatar = (props) => <Skeleton shape="avatar" {...props} />;
export const SkeletonIcon = (props) => <Skeleton shape="icon" {...props} />;
export const SkeletonButton = (props) => <Skeleton shape="button" {...props} />;
export const SkeletonMedia = (props) => <Skeleton shape="media" {...props} />;
